import { v4 as uuid } from "uuid";
import { useContext, useState } from "react";
import Card from "../../../components/card/card";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";
import { ReviewAppointmentStyled } from "./review-appointment.styles";
import { formatTimeSlot } from "../../../../../utils/common-utils";
import { createUserAppointment } from "../../../../../actions";
import dayjs from "dayjs";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { useAppDispatch } from "../../../../../store/hooks";
import { useFormContext } from "react-hook-form";
import { Box, FormControlLabel, Checkbox } from "@mui/material";

const ReviewAppointment = () => {
  const {
    state: {
      selectedClientAccount,
      selectedPets,
      activeStep,
      selectedTimeSlot,
      appointmentTypes,
      provider,
    },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const { handleSubmit, watch } = useFormContext();
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [isRescheduleEnabled, setIsRescheduleEnabled] = useState(false);

  const onConfirmAppointment = async (formValues: any) => {
    try {
      setLoading(true);
      const payload = {
        provider: provider?.actor_id,
        clientId: selectedClientAccount.integration_id,
        appointments: selectedPets.map((selectedPet) => {
          return {
            patientId: selectedPet.integration_id,
            start: dayjs(selectedTimeSlot.start).format(
              "YYYY-MM-DDTHH:mm:ssZZ"
            ),
            end: dayjs(selectedTimeSlot.end).format("YYYY-MM-DDTHH:mm:ssZZ"),
            clientReason: formValues?.[`reason_${selectedPet?.id}`],
            appointmentType:
              formValues?.[`appointment_type_${selectedPet?.id}`],
            prevTravel: 0,
          };
        }),
        canReschedule: isRescheduleEnabled,
        isUserSite: true,
      };

      await createUserAppointment(payload);
      userDispatcher({
        type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
        payload: activeStep + 1,
      });
    } catch (err: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: err.message || "An unexpected error occurred.",
        })
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card
      title={"Review Appointment"}
      description={
        <strong>
          {formatTimeSlot(selectedTimeSlot?.start, selectedTimeSlot?.end)}
        </strong>
      }
      btnTitle={"Confirm Appointment"}
      onHandleClick={handleSubmit(onConfirmAppointment)}
      progress={activeStep * 6}
      isLoadingConfirmBtn={loading}
    >
      <ReviewAppointmentStyled>
        {selectedPets?.map((pet, index: number) => {
          const findAppointmenType = appointmentTypes?.find(
            (x: any) =>
              x?.integrationId === watch()?.[`appointment_type_${pet?.id}`]
          );

          return (
            <Box className="row" key={index}>
              <Box>
                <Box className="label">Pet</Box>
                <Box className="value">{pet?.name}</Box>
              </Box>
              <Box>
                <Box className="label">Species</Box>
                <Box className="value">{pet?.species?.[0]?.label}</Box>
              </Box>
              <Box>
                <Box className="label">Appointment Type</Box>
                <Box className="value">{findAppointmenType?.label || ""}</Box>
              </Box>
            </Box>
          );
        })}
        {/* TODO: Add description for the reschedule button */}
        <div style={{ marginTop: 8, color: "#2460b8", fontSize: 14 }}>
          <strong>Note:</strong> We have an active cancellation list. If you would like to be added to the cancellation list, please check the box below. You will me emailed and texted if an earlier appointment becomes available.
        </div>
        <FormControlLabel
          control={
            <Checkbox
              checked={isRescheduleEnabled}
              onChange={(e) => setIsRescheduleEnabled(e.target.checked)}
              name="enableReschedule"
              color="primary"
              sx={{
                color: "var(--royal-blue-color)",
                "&.Mui-checked": {
                  color: "var(--royal-blue-color)",
                },
                "& .MuiSvgIcon-root": {
                  borderRadius: "6px",
                },
              }}
            />
          }
          label={
            <span style={{ fontWeight: 500, fontSize: 15 }}>
              Add Me to the Cancellation List
            </span>
          }
        />
      </ReviewAppointmentStyled>
    </Card>
  );
};

export default ReviewAppointment;
